export const state = {
  pasDeTravail: undefined,
  pasDeTravails: [],
  sousPasDeTravail: undefined,
  sousPasDeTravails: []
}